import { xor } from 'lodash';

const compareNewAnswerToExistingAnswer = (answer, allAnswers) => {
  if (answer.length) {
    const existingAnswers = allAnswers
      .filter(
        (ans) =>
          ans.sectionId === answer[0].sectionId &&
          ans.questionId === answer[0].questionId
      )
      .map((ans) => ans.optionId);

    return (
      xor(
        existingAnswers,
        answer.map((ans) => ans.optionId)
      ).length === 0
    );
  }
  const existingAnswer = allAnswers.find(
    (ans) =>
      ans.sectionId === answer.sectionId && ans.questionId === answer.questionId
  );
  if (existingAnswer) {
    if (answer.type === 'radio') {
      return existingAnswer.optionId === answer.optionId;
    }
    if (answer.type === 'percent') {
      return existingAnswer.value === answer.value;
    }
  }
  return false;
};

export default compareNewAnswerToExistingAnswer;
